import { FC } from "react";
import { NormalizedCostWidgetTableView } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/table/NormalizedCostWidgetTableView";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupDataSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataSelector";
import { normalizedCostWidgetSetupDataLoadingSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataLoadingSelector";
import { normalizedCostWidgetSetupVisualizationSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationSelector";

export const NormalizedCostWidgetSetupTableView: FC = () => {
  const data = useAppSelector(normalizedCostWidgetSetupDataSelector);
  const loading = useAppSelector(normalizedCostWidgetSetupDataLoadingSelector);
  const visualization = useAppSelector(
    normalizedCostWidgetSetupVisualizationSelector,
  );

  return (
    <NormalizedCostWidgetTableView
      normalized={data?.normalized}
      regular={data?.regular_cost}
      loading={loading}
      visualization={visualization}
    />
  );
};
